import { useEffect, useState } from "react"
import { getBimRevitFileAvailability } from "./queries"

const useBimData = (productId: string, locale: string) => {
  const [hasBimRevitFile, setHasBimRevitFile] = useState<Boolean>(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!productId || !locale) return

    const getBimData = async () => {
      try {
        setIsLoading(true) // Set loading to true
        const bimResult = await getBimRevitFileAvailability(productId, locale)
        setHasBimRevitFile(bimResult)
      } catch (error) {
        console.error("Failed to fetch BIM data:", error)
        setHasBimRevitFile(false)
      } finally {
        setIsLoading(false)
      }
    }

    getBimData()
  }, [productId, locale])

  return { hasBimRevitFile: !!hasBimRevitFile, isLoading } // Expose loading state and BIM data
}

export default useBimData
